import { isEmptyRepo } from '../repoState';
import type { VcsRepository } from '../../../../../shared/types/routes/vcs/githubApp';

/** The legacy bulk-import modal's review-step filters. */
export type ImportAllFilters = {
  access: 'all' | 'public' | 'private';
  excludeForks: boolean;
  /** Only include repos pushed to within this many days; null means anytime. */
  updatedWithinDays: number | null;
};

/**
 * Whether a repo is part of an import-all batch: applies the wizard's filters (visibility,
 * forks, last-updated) plus the always-on eligibility rules the legacy bulk-import modal
 * enforced — skip repos that are already connected, have nothing to import (no branches),
 * or resolved no locator (unparseable clone URL).
 */
export function isRepoEligibleForImportAll(repo: VcsRepository, filters: ImportAllFilters, now: Date): boolean {
  if (filters.excludeForks && repo.isFork) {
    return false;
  }
  if (filters.access === 'public' && repo.isPrivate) {
    return false;
  }
  if (filters.access === 'private' && !repo.isPrivate) {
    return false;
  }
  if (filters.updatedWithinDays !== null && repo.updated) {
    const cutoff = new Date(now);
    cutoff.setDate(cutoff.getDate() - filters.updatedWithinDays);
    // A repo without an `updated` timestamp passes the filter, as in the legacy modal.
    if (new Date(repo.updated) < cutoff) {
      return false;
    }
  }
  // Always-on eligibility rules from the legacy bulk-import modal: skip repos that are
  // already connected, empty, or whose clone URL resolved to no locator.
  const hasLocator = Boolean(repo.locator);
  const isConnected = repo.connectedProjects.length > 0;
  return hasLocator && !isEmptyRepo(repo) && !isConnected;
}
